module.exports = __webpack_public_path__ + "img/av-2.png.eb40ecbc.svg";